module.exports = __webpack_public_path__ + "66c1211c909dc126dbb9d40725366fd2.svg";